import classnames from 'classnames';

import styles from './IconLink.module.scss';

import { Icon, IconType } from '@components/Icon';

export interface IconLinkProps {
    link: string;
    iconType?: IconType;
    title?: string;
    titlePositionRight?: boolean;
}

interface Props extends IconLinkProps {}

export function IconLink({ link, iconType = IconType.OPEN_LINK, title, titlePositionRight }: Props) {
    return (
        <a
            className={classnames([styles.root, titlePositionRight && styles.root_titlePositionRight])}
            href={link}
            target="_blank"
        >
            {!!title && title}
            <div className={styles.icon}>
                <Icon type={iconType} />
            </div>
        </a>
    );
}
